// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  background: linear-gradient(135deg, #FF8C00 0%, #5B4B8A 100%);
  color: white;
  padding: 0;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 5px 25px rgba(255, 140, 0, 0.2);
  backdrop-filter: blur(10px);
  width: 100%;
  overflow: visible;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  gap: 20px;
}

.brand-group {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  margin-left: 50px;
}

.logo-img-container {
  flex-shrink: 0;
  margin-left: 10px;
}

.logo-img {
  height: 120px;
  width: auto;
}

.logo-text-center {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  margin-left: 32px;
}

.logo-text-center h1 {
  font-size: 2.47em;
  font-weight: 800;
  margin-bottom: 0;
  font-family: 'Playfair Display', serif;
  letter-spacing: 1px;
  color: white;
  margin: 0;
}

.logo-text-center .tagline {
  font-size: 2.47em;
  font-weight: 800;
  margin: 0;
  font-family: 'Playfair Display', serif;
  letter-spacing: 1px;
  color: white;
}

.logo {
  display: none;
}

.nav {
  display: flex;
  gap: 30px;
  align-items: center;
  margin-left: 200px;
  flex-shrink: 0;
}

.nav a {
  color: white;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  position: relative;
  font-size: 0.95em;
}

.nav a::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 0;
  height: 3px;
  background: white;
  transition: width 0.3s ease;
  border-radius: 2px;
}

.nav a:hover::after {
  width: 100%;
}

.menu-toggle {
  display: none;
  background: none;
  border: none;
  color: white;
  font-size: 1.5em;
  cursor: pointer;
  padding: 10px 15px;
  z-index: 102;
  position: relative;
  transition: all 0.3s ease;
}

@media (max-width: 1565px) {
  .header {
    position: sticky;
    z-index: 100;
  }

  .header-content {
    flex-wrap: nowrap;
    padding: 10px 15px;
    gap: 10px;
    position: relative;
  }

  .logo-img-container {
    margin-left: 0;
  }

  .brand-group {
    gap: 8px;
    margin-left: 0px;
  }

  .logo-img {
    height: 68px;
  }

  .logo-text-center {
    margin-left: 10px;
  }

  .logo-text-center h1 {
    font-size: 1.2em;
    line-height: 1.1;
  }

  .logo-text-center .tagline {
    font-size: 1.2em;
    line-height: 1.1;
  }

  .menu-toggle {
    display: block;
    position: relative;
    margin-left: auto;
    align-self: center;
    z-index: 102;
    font-size: 1.8em;
    line-height: 1;
    padding: 10px 15px;
    background: none;
    border: none;
  }

  .nav {
    position: fixed;
    top: 120px;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    background: #FF8C00;
    gap: 0;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
    z-index: 101;
    width: 100%;
    margin-left: 0;
  }

  .nav.active {
    max-height: 500px;
  }

  .nav a {
    padding: 15px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    display: block;
    text-align: center;
  }

  .logo h1 {
    font-size: 1.4em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;EAC7D,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,6CAA6C;EAC7C,2BAA2B;EAC3B,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;EACnB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,sCAAsC;EACtC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,UAAU;IACV,OAAO;IACP,QAAQ;IACR,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,mBAAmB;IACnB,MAAM;IACN,aAAa;IACb,gBAAgB;IAChB,gCAAgC;IAChC,YAAY;IACZ,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,iDAAiD;IACjD,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".header {\r\n  background: linear-gradient(135deg, #FF8C00 0%, #5B4B8A 100%);\r\n  color: white;\r\n  padding: 0;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 100;\r\n  box-shadow: 0 5px 25px rgba(255, 140, 0, 0.2);\r\n  backdrop-filter: blur(10px);\r\n  width: 100%;\r\n  overflow: visible;\r\n}\r\n\r\n.header-content {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 0 20px;\r\n  gap: 20px;\r\n}\r\n\r\n.brand-group {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex-shrink: 0;\r\n  margin-left: 50px;\r\n}\r\n\r\n.logo-img-container {\r\n  flex-shrink: 0;\r\n  margin-left: 10px;\r\n}\r\n\r\n.logo-img {\r\n  height: 120px;\r\n  width: auto;\r\n}\r\n\r\n.logo-text-center {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  text-align: left;\r\n  margin-left: 32px;\r\n}\r\n\r\n.logo-text-center h1 {\r\n  font-size: 2.47em;\r\n  font-weight: 800;\r\n  margin-bottom: 0;\r\n  font-family: 'Playfair Display', serif;\r\n  letter-spacing: 1px;\r\n  color: white;\r\n  margin: 0;\r\n}\r\n\r\n.logo-text-center .tagline {\r\n  font-size: 2.47em;\r\n  font-weight: 800;\r\n  margin: 0;\r\n  font-family: 'Playfair Display', serif;\r\n  letter-spacing: 1px;\r\n  color: white;\r\n}\r\n\r\n.logo {\r\n  display: none;\r\n}\r\n\r\n.nav {\r\n  display: flex;\r\n  gap: 30px;\r\n  align-items: center;\r\n  margin-left: 200px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.nav a {\r\n  color: white;\r\n  text-decoration: none;\r\n  font-weight: 600;\r\n  transition: all 0.3s ease;\r\n  position: relative;\r\n  font-size: 0.95em;\r\n}\r\n\r\n.nav a::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: -8px;\r\n  left: 0;\r\n  width: 0;\r\n  height: 3px;\r\n  background: white;\r\n  transition: width 0.3s ease;\r\n  border-radius: 2px;\r\n}\r\n\r\n.nav a:hover::after {\r\n  width: 100%;\r\n}\r\n\r\n.menu-toggle {\r\n  display: none;\r\n  background: none;\r\n  border: none;\r\n  color: white;\r\n  font-size: 1.5em;\r\n  cursor: pointer;\r\n  padding: 10px 15px;\r\n  z-index: 102;\r\n  position: relative;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n@media (max-width: 1565px) {\r\n  .header {\r\n    position: sticky;\r\n    z-index: 100;\r\n  }\r\n\r\n  .header-content {\r\n    flex-wrap: nowrap;\r\n    padding: 10px 15px;\r\n    gap: 10px;\r\n    position: relative;\r\n  }\r\n\r\n  .logo-img-container {\r\n    margin-left: 0;\r\n  }\r\n\r\n  .brand-group {\r\n    gap: 8px;\r\n    margin-left: 0px;\r\n  }\r\n\r\n  .logo-img {\r\n    height: 68px;\r\n  }\r\n\r\n  .logo-text-center {\r\n    margin-left: 10px;\r\n  }\r\n\r\n  .logo-text-center h1 {\r\n    font-size: 1.2em;\r\n    line-height: 1.1;\r\n  }\r\n\r\n  .logo-text-center .tagline {\r\n    font-size: 1.2em;\r\n    line-height: 1.1;\r\n  }\r\n\r\n  .menu-toggle {\r\n    display: block;\r\n    position: relative;\r\n    margin-left: auto;\r\n    align-self: center;\r\n    z-index: 102;\r\n    font-size: 1.8em;\r\n    line-height: 1;\r\n    padding: 10px 15px;\r\n    background: none;\r\n    border: none;\r\n  }\r\n\r\n  .nav {\r\n    position: fixed;\r\n    top: 120px;\r\n    left: 0;\r\n    right: 0;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    background: #FF8C00;\r\n    gap: 0;\r\n    max-height: 0;\r\n    overflow: hidden;\r\n    transition: max-height 0.3s ease;\r\n    z-index: 101;\r\n    width: 100%;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .nav.active {\r\n    max-height: 500px;\r\n  }\r\n\r\n  .nav a {\r\n    padding: 15px;\r\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\r\n    display: block;\r\n    text-align: center;\r\n  }\r\n\r\n  .logo h1 {\r\n    font-size: 1.4em;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
